module.exports = __webpack_public_path__ + "static/mobilenav-back-dont-0866cd00c2cd760ff380b4cb155a3a0d.png";